<template>
  <div class="mx-auto w-full p-2 rounded" :class="bgColor">
    <Disclosure v-slot="{ open }" v-bind="$attrs" as="div">
      <DisclosureButton
        class="font-bold w-full flex items-center rounded-lg py-2 gap-1 focus:outline-none focus-visible:ring focus-visible:ring-primary"
      >
        <span
          :class="open ? 'rotate-90 transform' : ''"
          class="i-mdi-chevron-right transition-transform size-6"
        />

        <div>
          <slot name="header">{{ title }}</slot>
        </div>

      </DisclosureButton>

      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <DisclosurePanel class="px-7 pb-2">
          <slot />
        </DisclosurePanel>
      </transition>
    </Disclosure>
  </div>
</template>

<script lang="ts" setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

defineProps({
  title: String,
  bgColor: {
    type: String,
    default: 'bg-slate-50'
  }
})
</script>
